import { get, has } from "lodash";

import useFlags from "./useFlags";

export function useFeatures(id, enableOnMissing = false) {
  const { loadingConfig, flags } = useFlags();

  if (loadingConfig) return enableOnMissing;
  if (has(flags, id)) return get(flags, id);
  return enableOnMissing;
}

export default useFeatures;
